import { CartState } from 'types/redux'

const preloadedCartState: CartState = {
  collectiveOrder: false,
  data: null,
  voucherAccepted: false,
  voucherLoad: false,
  voucherError: null
}

export default preloadedCartState
